import {getFeatureInteraction, postFeatureInteraction} from 'shared/actions/feature-interactions';
import {flashMessage} from 'shared/actions/notifications';

export const showSuccessfulCleverLogin = () => (dispatch) =>
  getFeatureInteraction('successful-clever-login').catch(() => {
    postFeatureInteraction('successful-clever-login');
    return dispatch(flashMessage('Success! Your Clever account has been linked.'));
  });
